import { render } from "./ResetPassword.vue?vue&type=template&id=76dc323e&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=76dc323e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76dc323e"

export default script